exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".label-required[data-v-61f44978]:after{content:\" *\";color:#f44}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-61f44978","scoped":true,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./App/Components/Monitoring/MonitoringSendEmailReportAgent.vue
// module id = 1083
// module chunks = 0